import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: Record<string, GenericFormItem[]> = {
  first: [
    {
      gridXs: 6,
      label: 'CLIENT_NAME_KEY',
      stateKey: 'name',
    },
    {
      gridXs: 6,
      label: 'CLIENT_EXTERNAL_CODE_KEY',
      stateKey: 'external_client_code',
    },
    {
      gridXs: 6,
      label: 'SECURITY_GROUP_KEY',
      stateKey: 'active_directory.security_group',
      type: 'readyonly',
      disabled: true,
    },
    {
      gridXs: 6,
      label: 'PROFILE_PATH_KEY',
      stateKey: 'active_directory.profile_path',
    },
  ],

  licenses: [
    {
      gridXs: 6,
      label: 'LICENSES_KEY',
      stateKey: 'licenses.client_license.license_limit',
    },
    {
      gridXs: 6,
      label: 'LICENSES_AVAILABLE_KEY',
      stateKey: 'licenses.available_licenses_to_client',
      type: 'readyonly',
      disabled: true,
    },
  ],

  virtualizer: [
    {
      gridXs: 4,
      label: 'VIRTUALIZER_KEY',
      stateKey: 'user_connection.virtualizer',
      isSelect: true,
      options: [
        { value: '', label: '' },
        { value: 'connect', label: 'ConnectSky' },
        {
          value: 'rdp',
          label: `Microsoft Remote Desktop (${i18n.t('FILE_KEY')})`,
        },
        {
          value: 'rdp_direct',
          label: 'Microsoft Remote Desktop (Direct Connect)',
        },
        { value: 'rdp_app', label: 'Microsoft Remote Desktop (RemoteApp)' },
        { value: 'connect_direct', label: 'ConnectSky (Direct Connect)' },
        { value: 'tsplus', label: 'TSPlus (WebBrowser HTML5)' },
        { value: 'tsplus_remote_app', label: 'TSPlus (RemoteApp)' },
        {
          value: 'tsplus_all',
          label: 'TSPlus (WebBrowser HTML and RemoteApp)',
        },
        { value: 'aspw', label: 'ASPW (WebBrowser)' },
        { value: 'aspw_all', label: 'ASPW (WebBrowser and RemoteApp)' },
      ],
    },
    {
      gridXs: 4,
      label: 'PRIMARY_PORT_KEY',
      stateKey: 'user_connection.connect_port',
      type: 'number',
    },
    {
      gridXs: 4,
      label: 'SECONDARY_PORT_KEY',
      stateKey: 'user_connection.service_port',
      type: 'number',
    },
  ],
  connectionType: [
    {
      gridXs: 12,
      label: 'CONNECTION_TYPE_KEY',
      stateKey: 'user_connection.connection_type.type',
      isSelect: true,
      options: [
        {
          value: 'public',
          label: i18n.t('ACCESS_PUBLIC_KEY'),
        },
        {
          value: 'private',
          label: i18n.t('PRIVATE_PUBLIC_KEY'),
        },
      ],
    },
  ],
};

export default fields;
